<style>
  .modal-dialog {
    width: 900px;
    max-width: 900px;
  }
</style>
<div class="modal-header">
  <h4 class="modal-title">Import Timecards</h4>
  <button type="button" class="btn-close" aria-hidden="true" (click)="cancel()"></button>
</div>
<div class="modal-body">
  <form name="$parent.importTimecards" novalidate>
    <span us-spinner spinner-key="modalSpinner"></span>
    <nbc-modal-alert></nbc-modal-alert>
    <div class="form-horizontal">
      <div class="row form-group d-flex">
        <div class="col-md-2">
          <div style="width:100%">
            <nbc-contact-auto listItemId="contactsearchimport" required="true" placeholder="Contact Name">
            </nbc-contact-auto>
          </div>
        </div>
        <div class="col-md-2">
          <input class="form-control required-outline event-show-name-el text-font"
                 maxlength="255"
                 type="text"
                 placeholder="Event/Show Name"
                 [(ngModel)]="eventShowName"
                 value="{{eventShowName}}"
                 title="{{eventShowName}}"
                 name="eventShowName" /> 
        </div>
        <div class="col-md-2">
          <nbc-select [source]="sports"
                      [(model)]="sportSelected"
                      display="description"
                      value="id"
                      name="sports"
                      placeHolderValue="-1"
                      placeHolderDisplay="Sports"
                      (modelChange)="onSportsChange($event)"></nbc-select>
        </div>
        <div class="col-md-2">
          <nbc-select [source]="networks"
                      [(model)]="networkSelected"
                      display="description"
                      value="id"
                      name="networks"
                      placeHolderValue="-1"
                      placeHolderDisplay="Networks"
                      (modelChange)="onNetworkChange($event)"></nbc-select>
        </div>
        <div class="col-md-2">
          <nbc-select [source]="employeeTypes"
                      [(model)]="employeeTypeSelected"
                      display="description"
                      value="id"
                      name="employeetypes"
                      placeHolderValue="-1"
                      placeHolderDisplay="Employee Type"
                      (modelChange)="onEmployeeTypeChange($event)"></nbc-select>
        </div>
        <div class="col-lg-2">
          <glaccount name="import_tc_glAccount"
                     nbcClass="form-control"
                     placeHolder="Enter GL Account"
                     [(model)]="glAccount"
                     typeaheadOptionLimit="20">
          </glaccount>
        </div>
      </div>

    </div>
    <div class="row">
      <div class="col-md-3" *ngIf="files && files.length == 0">
        <a (click)="fileupload()" class="fileUpload btn btn-primary" for="file-upload">Choose File</a>
        <input id="file-upload" type="file" style="display:none" accept=".xlsx" (change)="importTimecards($event)" name="importfile" />
      </div>
    </div>
    <div class="row">
      <div class="row">
        <div class="col-md-4">
          <div *ngFor="let file of files; let $index=index;">
            <div class="document-upload-view ps-3">
              <i class="fa fa-file"></i>
              <span>{{file.name}}</span>
              <i class="fa fa-times-circle"
                 (click)="clearFile($event)"></i>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="contact-details importtimecards" *ngIf="importtimecards.length">
            Contact Name - {{fileContactName}}
          </div>
        </div>
        <div class="col-md-4">
          <div class="contact-details importtimecards" *ngIf="importtimecards.length">
            Contact SSO - {{fileContactSSO}}
          </div>
        </div>
      </div>
      <span>
        <button class="btn btn-primary" style="float:right" *ngIf="importtimecards && files && files.length && !importtimecards.length" (click)="import()">
          Preview
        </button>
      </span>
    </div>

    <!--<div class="clearfix" ng-show="showResultsContents === true">
      <div pagination-label page-size="{{wbsecodes.pageSize}}" current-page="{{wbsecodes.currentPage}}" total-records="{{wbsecodes.totalRecords}}"></div>
      <pagination template-url="/Scripts/app/views/directives/pagination.html" total-items="wbsecodes.totalRecords" ng-model="budgetQuery.currentPage" items-per-page="wbsecodes.pageSize" class="pagination-sm pull-right" boundary-links="true" rotate="false" ng-change="budgetSearch()" max-size="7" ng-show="showResultsContents === true"></pagination>
  </div>-->
  <div class="row">
    <div class="col-lg-12">
      <div class="table-responsive clearfix" *ngIf="importtimecards && importtimecards.length">
        <table class="table table-hover table-condensed">
          <thead>
            <tr>
              <th>Sno#</th>
              <th>Date Worked</th>
              <th>Day Type</th>
              <th>WBSE</th>
              <th>Rate</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let timecard of importtimecards; let $index=index;">
              <td>{{timecard.id*-1}}</td>
              <td>{{timecard.activityDate | date:"MM/dd/yyyy"}}</td>
              <td>{{timecard.dayType.description}}</td>
              <td>{{timecard.wbse}}</td>
              <td>{{timecard.customRate | number: '1.4-4'}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="row float-end mb-2">
    <div class="col-md-12 p-1">
      <button class="btn btn-primary" style="float:right;margin-right:20px;" *ngIf="importtimecards && importtimecards.length" [disabled]="!contact" (click)="confirm()">
        Import
      </button>
    </div>
    </div>
</form>
</div>

